import { KPITeamGroup } from "./KPITeamGroup";

export function remoteKPIToKPITeamGroups({
  activeSections,
  goals,
}: {
  goals: readonly {
    greaterThan: number | null;
    lessThan: number | null;
    section: {
      id: string;
    };
  }[];
  activeSections: readonly {
    id: string;
    title: string | null;
    assignedTeam: {
      id: string;
      name: string;
      icon: string | null;
      color: string | null;
    } | null;
  }[];
}) {
  return activeSections.reduce((acc, activeSection) => {
    const team = activeSection.assignedTeam;
    if (!team) {
      return acc;
    }
    const teamGroupIndex = acc.findIndex(({ teamId: id }) => team.id === id);
    const goal = goals.find(({ section }) => section.id === activeSection.id);
    const goalValue = goal?.lessThan ?? goal?.greaterThan ?? 0;

    if (teamGroupIndex !== -1) {
      return acc
        .map((teamGroup) => {
          if (
            teamGroup.teamId === team.id &&
            !(activeSection.title === null || activeSection.title === "")
          ) {
            return {
              ...teamGroup,
              subTeams: [
                ...teamGroup.subTeams,
                {
                  goalValue,
                  name: activeSection.title,
                  sectionId: activeSection.id,
                },
              ].sort((a, b) => (a.name > b.name ? 1 : -1)),
            };
          }
          return teamGroup;
        })
        .sort((a, b) => (a.name > b.name ? 1 : -1));
    }

    return [
      ...acc,
      {
        teamId: team.id,
        name: team.name,
        icon: team.icon,
        color: team.color,
        sectionId: activeSection.title === null ? activeSection.id : undefined,
        goalValue: activeSection.title === null ? goalValue : 0,
        subTeams:
          activeSection.title === null
            ? []
            : [
                {
                  goalValue,
                  name: activeSection.title,
                  sectionId: activeSection.id,
                },
              ].sort((a, b) => (a.name > b.name ? 1 : -1)),
      },
    ].sort((a, b) => (a.name > b.name ? 1 : -1));
  }, [] as KPITeamGroup[]);
}
